<div class="dialog-backdrop" *ngIf="isOpen">
  <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="data-requirements-title">
    <header class="dialog-header">
      <h2 id="data-requirements-title">Privacy & Data Requirements</h2>
      <button type="button" class="close-button" (click)="close()" aria-label="Close privacy and data dialog">×</button>
    </header>
    <div class="dialog-body">
      <p>
        To meet Google OAuth verification requirements, ClariChat provides a public homepage and Privacy Policy on the
        same domain. The Privacy Policy describes how we access, use, store, and share Google user data.
      </p>
      <ul>
        <li>Homepage is a static URL that does not redirect to another domain.</li>
        <li>Privacy Policy is public, easy to find, and hosted on the same domain.</li>
        <li>Only the data disclosed in the Privacy Policy is accessed and used.</li>
        <li>We retain data only as long as needed for your account or until deletion is requested.</li>
        <li>We use verified domains that we control for homepage and policy links.</li>
      </ul>
      <p>
        If you need a Terms of Service page, contact support and we will provide the latest version and add it to the
        homepage footer.
      </p>
    </div>
  </div>
</div>
